import { render, staticRenderFns } from "./RateTaxPersonModal.vue?vue&type=template&id=4e9b8006&scoped=true"
import script from "./RateTaxPersonModal.vue?vue&type=script&lang=js"
export * from "./RateTaxPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b8006",
  null
  
)

export default component.exports